import React from "react";
import Image from "next/image";
import { PLATE_FORM_ENUM, PLATE_FORM_ICON_MAP } from "../constants";

export interface SocialIconProps {
  type: PLATE_FORM_ENUM;
  className?: string;
  onShare?: (platform: PLATE_FORM_ENUM) => any;
}

export const SocialIcon: React.FC<SocialIconProps> = ({ type, className, onShare }) => {
  const icon = PLATE_FORM_ICON_MAP[type];
  const alt = PLATE_FORM_ENUM[type];

  const handleShare = async () => {
    onShare?.(type);
  };

  return (
    <div
      className={`w-12 h-12 bg-dark-special rounded-lg flex items-center justify-center cursor-pointer hover:bg-gray-600 transition-colors ${className}`}
      onClick={handleShare}
    >
      <Image src={icon} alt={alt} width={20} height={20} />
    </div>
  );
}


